
const baseUrl = process.env.NODE_ENV === 'development' 
                        ? "http://localhost:9000" 
                        :"https://communityoflearning.accenture.com/communityoflearning-apis";
export { baseUrl }; 

